import { render, staticRenderFns } from "./SideBarPrescriber.vue?vue&type=template&id=6165e93e&scoped=true&"
import script from "./SideBarPrescriber.vue?vue&type=script&lang=ts&"
export * from "./SideBarPrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarPrescriber.vue?vue&type=style&index=0&id=6165e93e&lang=scss&scoped=true&"
import style1 from "./SideBarPrescriber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165e93e",
  null
  
)

export default component.exports